export default __webpack_public_path__ + "static/media/new_06.b0c55209.jpg";